module.exports = __webpack_public_path__ + "img/img-68.3d24bf69.png";